module.exports = __webpack_public_path__ + "img/1554446828.7fe353f2.jpg";